import Vue from 'vue';

import { GROUP_STATUS } from '@/helpers/groups';

export default {
  SET_GROUPSETS_SELF_REGISTRATION(state, params) {
    state.groupsetsSelfRegistration = params;
  },
  SET_FIRST_GROUP_ORDER(state, params) {
    const workingGroupSet = state.groupsetsSelfRegistration.groupSets.find(set => set.id === params.groupSetId);
    if (!workingGroupSet) {
      return;
    }
    let groups = _.cloneDeep(workingGroupSet.groups);
    const userCurrentGroup = groups.find(group => group.id === params.groupId);
    if (!userCurrentGroup) {
      return;
    }
    groups = [userCurrentGroup, ...groups.filter(group => group.id !== userCurrentGroup.id)];
    Vue.set(workingGroupSet, 'groups', groups);
  },
  SET_GROUP_STATUS(state) {
    for (const groupset of state.groupsetsSelfRegistration.groupSets) {
      const groupStudentIsSubscribed = groupset.subscribedGroupId;
      const isRegistrationExpired = groupset.isRegistrationDateExpired;

      for (const group of groupset.groups) {
        if (group.id === groupStudentIsSubscribed) {
          Vue.set(group, 'status', GROUP_STATUS.STUDENT_SUBSCRIBED_IN_GROUP);

          continue;
        }

        if (isRegistrationExpired) {
          Vue.set(group, 'status', GROUP_STATUS.REGISTRATION_EXPIRED);

          continue;
        }

        if (groupset.participantsLimit === group.participants.length && groupset.participantsLimit > 0) {
          Vue.set(group, 'status', GROUP_STATUS.GROUP_FULL);

          continue;
        }

        if (group.hasStudentAnswer) {
          Vue.set(group, 'status', GROUP_STATUS.STUDENT_ANSWERED_ACTIVITY_BY_ANOTHER_GROUP);

          continue;
        }

        if (group.hasGroupAnswer) {
          Vue.set(group, 'status', GROUP_STATUS.GROUP_HAS_CORRECTION);

          continue;
        }

        if (group.hasMyGroupAnswer) {
          Vue.set(group, 'status', GROUP_STATUS.MY_GROUP_HAS_ANSWER);

          continue;
        }

        Vue.set(group, 'status', GROUP_STATUS.CAN_JOIN_GROUP);
      }
    }
  },
  REMOVE_GROUPS_STATUS(state) {
    for (const groupset of state.groupsetsSelfRegistration.groupSets) {
      for (const group of groupset.groups) {
        delete group.status;
      }
    }
  },
  INSERT_USER_INTO_GROUP(state, { groupSetId, groupId, enrollmentId, isSwitchingGroups, participant }) {
    const groupsetIndex = state.groupsetsSelfRegistration.groupSets.findIndex(groupsetIndex => groupsetIndex.id === groupSetId);
    const updatedGroupset = state.groupsetsSelfRegistration.groupSets[groupsetIndex];

    if (groupsetIndex > -1) {
      const groupIndex = updatedGroupset.groups.findIndex(group => group.id === groupId);

      if (groupIndex > -1) {
        const updatedGroup = updatedGroupset.groups[groupIndex];

        if (isSwitchingGroups) {
          const participantOldGroupIndex = updatedGroupset.groups.findIndex(group => group.id === updatedGroupset.subscribedGroupId);
          const participantOldGroup = updatedGroupset.groups[participantOldGroupIndex];
          const participantIndexInOldGroup = participantOldGroup.participants.findIndex(participant => participant.enrollmentId === enrollmentId);

          participantOldGroup.participants.splice(participantIndexInOldGroup, 1);
        }

        updatedGroup.participants.push(participant);
        updatedGroupset.subscribedGroupId = updatedGroup.id;
      }
    }
  }
};
